export const API = {
  ManageSchedule: "/UserSchedule",
  // Tenant
  SearchHedgeFund: "/services/app/Tenant/Search",
  //Get Recent Chats
  GetRecentChat: "/Chat/recent",

  //Get list of strategies
  GetListOfStrategies: "/services/app/Dashboard/GetStrategyFundCount",

  //Get Strategies
  GetStrategies: "/Strategy",
  FundAssociatedStrategies : "/Strategy/FundAssociatedStrategies",

  //Get Regions
  GetRegion: "/Regions",

  //Follow Fund
  FollowFund: "/Fund/Follow",
  FundSpotlight : "/Fund/FundSpotLights",

  //Get Strategies
  GetSubSpecialties: "/SubSpecialty/Get",
  
  //Meetings
  GetMeetings: "/Appointment",
  CreateAppointment: "/Appointment",
  GetMeetingDetail: "/Appointment",
  GetDashboardMeetings: "/services/app/Dashboard/GetMeetings",
  // HedgeFund Detail
  GetHedgeFund : "/services/app/Tenant/GetHedgeFundDetail",

  //Fund API
  SearchFund: "/fund/search",
  GetFund: "/fund",
  Strategies: "/Strategy",
  Invest: "/fund/Invest",
  SubSpecialties : "/SubSpecialty/SubSpecialties",
  GetFundCompare : "/Fund/GetCompareFundDetail",
  GetFundList : "/Fund/Funds",

  //Get invest funds
  InvestedFund: "/fund/getInvestedFunds",

  //Chat
  CreateRoom: "/chat",
  GetRooms: "/chat/rooms",
  UploadFile: "/chat/UploadFile",
  GetRoomMessages: "/chat/GetRoomMessages",
  GetArchive: "/Room/GetArchive",
  UpdateArchive: "/Chat/Archive",
  // SEEN MESSAGES
  SeenMessages: "/MessageSeen",

  //Auth
  signUp: "/services/app/Account/Register",
  companyExist: "/services/app/Account/IsCompanyNameExists",
  EmailExist: "/services/app/Account/IsEmailExists",
  Login: "/TokenAuth/Authenticate",
  fundManagers: "/Fund/managers",
  freeSlots: "/services/app/HedgeFund/GetHedgeUserFreeSlots",
  getUsers: "/services/app/User/GetAll",
  forgetPassword: "/services/app/User/ForgetPassword",
  setNewPassword: "/services/app/User/SetNewPassword",
  cooperativeEmail: "/services/app/Account/IsTenantCooperativeEmail",
  fundBioUsers : "/services/app/User/GetUsersWithFundBios",
  //Get profile Details
  GetProfileDetail: "/services/app/Profile/GetProfileDetail",
  GetAllocatorProfileDetail : "/services/app/Profile/GetAllocatorProfileDetail",
  //Dashboard
  fundSpotlight: "/services/app/Dashboard/GetFunds",
  getDashboardConfig: "/DashboardConfiguration/Get",
  updateDashboardConfig: "/DashboardConfiguration/CreateOrUpdate",

  //Investor Type
  // InvestorType: "/services/app/InvestorType/GetAll",

  //Cuurent User Details
  CurrentUser: "/services/app/User/GetCurrentUserDetails",

  //Update User
  UpdateUser: "/services/app/User/UpdateProfileInfo",

  //CreateUser
  CreateUser: "/services/app/User/Create",

  //Two Factor Auth
  TwoFactor: "/TokenAuth/VerifyTwoFactorCode",
  // Send Verification Code
  SendTwoFactorCodeUrl : "/services/app/User/SendTwoFactorCode",
  SendVerifyPhoneNumberUrl: "/services/app/User/SendPhoneVerificationCode",
  SendTwoFactorCodeToEmailUrl : "/services/app/User/SendTwoFactorCodeToEmail",

  // Tenant Users
  GetTenantUsers : "/services/app/Tenant/GetCurrentTenantUsers",
  GetCompanyUsers : "/services/app/Tenant/GetCompanyTenantUsers",

  //Verify Phone
  VerifyPhone: "/TokenAuth/VerifyCode",

  //Create Post
  CreatePost: "/PostFeed/Create",
  // Record Files
  getRecordFiles : "/RecordFile/Records",
  //Get New Posts
  GetPost: "/PostFeed/HedgeFund",
  CurrentCompanyPostFeed: "/PostFeed/CurrentCompanyPostFeed",
  GetCompanyPostFeed : "/PostFeed/CompanyPostFeed",
  //Get My Posts
  MyPost: "/PostFeed/CurrentUserPostFeed",

  // Accept Terms and Condition
  AcceptTermsCondition: "/PostFeed/Create",

  // Get Meeting Details
  GetMeetingDetails: "/Appointment/GetMeetingDetails",

  // Delete Meeting
  DeleteMeeting: "/Appointment/DeleteAppointment",

  //Get Post Details
  GetPostDetails: "/PostFeed/GetPostDetail",

  //Update Post
  UpdatePost: "/PostFeed/Update",

  //Delete Post
  DeletePost: "/PostFeed/Delete",

  TermsAndCondition: "/services/app/AssignedAgreementsService/Create",

  //Contact FCN Admin
  FCNQuery: "/FcnQuery/Create",

  //Get All Users
  GetAllUser: "/services/app/User/GetAllUsers",

  //Get User Details
  GetUser: "/services/app/User/GetUserDetail",

  //Update User Details
  UpdateUserDetail: "/services/app/User/UpdateCompanyUserProfileInfo",

  //Update User Status
  UpdateUserStatus: "/services/app/User/UpdateStatus",

  //Get All Documents
  GetDocument: "/Document/Detail",

  //Upload Document
  UploadDocument: "/Document/Upload",

  //Update Document Status
  UpdateDocumentStatus: "/Document/Status",
  //Alert
  GetAlerts: "/services/app/Alert/GetAlerts",
  UpdateToSeen: "/services/app/Alert/UpdateToSeen",

  // MessageSeen
  GetUnSeenMessages: "/MessageSeen/UnSeenMessages",

  //GetRecentPost
  GetRecentPost: "/services/app/Dashboard/GetRecentPostFeeds",

  //Roles and Permissions
  RolesAndPermissions: "/services/app/Session/GetCurrentLoginInformations",

  //Get User Roles
  GetRoles: "/services/app/User/GetRoles",
  // allocator Strategy
  AllocatorStrategy: "AllocatorStrategy/GetCurrentAllocator",
  Strategy: "/Strategy",
  UpdateAllocatorStrategy: "/AllocatorStrategy/Update",
  UpdateTenant: "/services/app/Tenant/UpdateCurrentTenantInfo",
  UpdateTenantCoverImage: "/services/app/Tenant/UpdateCoverImage",
  UpdateTenantCompantLogo: "/services/app/Tenant/UpdateLogoImage",
  fcnAdminList: "/services/app/Tenant/GetAdminList",
  
  // Allocator Info
  CreateAllocatorInfo : "/AllocatorInfo/Create",
  GetAllocatorInfo : "/AllocatorInfo/AllocatorInfo",
  UpdateAllocatorInfo : "/AllocatorInfo/Update",
  UpdateFSI : "/AllocatorInfo/UpdateFSI",
  UpdateIDP : "/AllocatorInfo/UpdateIDP",
  UpdateNDE : "/AllocatorInfo/UpdateNDE",
  UpdateIC : "/services/app/Tenant/ChangeTenantInvestorType",

  //Update User Password
  UpdatePassword: "/services/app/User/ResetPassword",

  // change password

  ChangePassword: "services/app/User/ChangePassword",

  // Connections

  GetMyConnections : "/Connection/GetMyConnections",
  AllocatorNetworkStats : "/Connection/ConnectionStats",
  CreateConnection : "/Connection/Create",
  UpdateConnection : "/Connection/Update",
  InvestorType : "/services/app/InvestorType/GetAll",
  DeleteConnection : "/Connection/Delete",

  // Allocator Contacts
  GetAllocatorContact : "/AllocatorContact/AllocatorContacts",
  ImportAllocatorContact : "/AllocatorContact/ImportContacts",
  SendInvitationEmail : "/AllocatorContact/AllocatorInvitationEmail",

  //Create Notes
  CreateNotes: "/Note/Create",

  //Get Notes
  GetNotes: "/Note/Get",
  //Get Performance Metrics Search Result
  GetPerformanceMetricsSearchResult: "/Fund/GetPerformanceSearchResult",
    //Get Risk Report Search Result
  GetRiskReportSearchResult: "/Fund/GetRiskReportSearchResult",
  RiskReportSearchResultByMonth: "/Fund/RiskReportSearchResultByMonth",
  // Create Recommended Fund
  CreateRecommendedFund : "/FcnQuery/RecommendFund",
  // AuditLogs 
  CreateAuditLogs : "/AuditLog/AuditLog",
  
  // Impersonation Login
  AdminLogin : "/TokenAuth/AuthenticateImpersonateUser",
  // Preferences
  GetUserPreferences: "/Preference/GetUserPreferences",
  GetEmailTemplates : "/Preference/GetEmailTemplates",
  CreateUserPreference : "/Preference/InsertOrUpdatePreference",

  //Get all Meetings
  GetMonthlyMeetings: "/Appointment/GetMonthlyMeetingDetails"
};

export const setStorageItem = (storage, key, value, callback) => {
  var result = storage.setItem(key, value);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};

export const getStorageItem = (storage, key, callback) => {
  var result = storage.getItem(key);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};

export const setSessionStorageItem = (sessionStorage, key, value, callback) => {
  var result = sessionStorage.setItem(key, value);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};

export const getSessionStorageItem = (sessionStorage, key, callback) => {
  var result = sessionStorage.getItem(key);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};
